import { isEmpty } from 'lodash'
import { DashboardWidgetData } from 'features/widget/types'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import { MetricSeries as MetricSeriesDataset } from 'schemas/MetricSeriesSchema'
import MetricSeries from 'enums/MetricSeries'
import { isDatasetLanguageNotSupported } from './languageNotSupportedChecker'

export const isEmptyDataset = (dataset: MetricSeriesDataset[]) =>
  dataset.find((series) => isEmpty(series.set)) !== undefined

const isEmptyDatasetOrZeroMentions = (dataset: MetricSeriesDataset[]) => {
  if (isEmptyDataset(dataset)) {
    return true
  }

  if (isDatasetLanguageNotSupported(dataset)) {
    return false
  }

  const mentions = dataset.find((series) => series.seriesName === MetricSeries.TOTAL_BUZZ)

  return !mentions || mentions.set![0] === 0
}

export const dataNotReturned = (entry: DashboardWidgetData<AnnotatedMetricResult>) =>
  isEmptyDatasetOrZeroMentions(entry.results![0].data.metrics![0].dataset!)
